export default "__VITE_ASSET__C81l44Mx__"